import { CLOSE_MODAL, OPEN_MODAL, RESET_MODAL, SET_MODAL_READY } from 'reducers/actions-types';
import scrollActions from 'reducers/modules/scroll/actions';
import panelActions from 'reducers/modules/panel/actions';
import { login } from 'constants/api-urls';

let cachedPanelState;

export default Object.freeze({
    /**
     * Open modal
     * @param {string} content
     * @param {string} layout
     * @param {string} href
     * @param {any} meta
     * @param {boolean} isAsync
     * @param {boolean} mustRefreshOnClose
     * @return {Function}
     */
    open({ content, layout, href, meta, isAsync, mustRefreshOnClose }) {
        return function(dispatch, getState) {
            cachedPanelState = getState().panel;
            if (cachedPanelState.content) {
                dispatch(panelActions.close());
            }
            dispatch(scrollActions.lock());
            dispatch({ type: OPEN_MODAL, content, layout, href, meta, isAsync, mustRefreshOnClose });
        };
    },
    close() {
        return function(dispatch, getState) {
            const { mustRefreshOnClose } = getState().modal;
            if (!getState().modal.isVisible) {
                return;
            }

            // if this prop is true we need to reload the whole application
            if (mustRefreshOnClose) {
                window.location.href = login(window.location.href); // reload the page forcing the login
            }

            if (cachedPanelState && cachedPanelState.content) {
                dispatch(panelActions.open({ ...cachedPanelState }));
            } else if (!getState().search.isActive) {
                dispatch(scrollActions.unlock());
            }

            dispatch({ type: CLOSE_MODAL });
        };
    },
    reset() {
        return function(dispatch) {
            dispatch({ type: RESET_MODAL });
        };
    },

    /**
     * Set state
     * @param {boolean} isReady
     * @return {Function}
     */
    setReady({ isReady }) {
        return function(dispatch) {
            dispatch({ type: SET_MODAL_READY, isReady });
        };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/modal/actions.js